import type {GiftCardProviders} from "../types/types";

/**
 * Logic: anystring@anystring.anystring
 * We just want to filter away obvious errors.
 * @param email
 */
export const emailValidator = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+[a-zA-Z0-9]$/;
  return emailRegex.test(email);
};

/**
 * Logic: contains any of the specified domains = false
 * Excludes most used domains.
 * Usecases: Company OneOff
 * @param email
 */
export const companyEmailDomainValidator = (email: string): boolean => {
  const emailDomainRegex = /gmail.com|gmail.dk|yahoo.dk|yahoo.com|yahoo.fr|live.dk|live.com|hotmail|aol.com|msn.dk|msn.com|@mail.dk/;
  return !emailDomainRegex.test(email);
};

/**
 * Depending on the country prefix different logic applies.
 * If 45 or 47 (Denmark, Norway) the total length should always be 10 digits.
 * If 46 (Sweden) it's the wild west, anything goes.
 * @param phoneNumber
 * @returns
 */
export const phoneNumberValidator = (phoneNumber: number): boolean => {
  const phoneNumberString = phoneNumber.toString();
  const prefix = phoneNumberString.substring(0, 2);
  if (prefix === "45" || prefix === "47") {
    return phoneNumberString.length === 10 ? true : false;
  } else if (prefix === "46") {
    return true;
  }
  return false;
};

/**
 * Checks whether or not the given code corresponds to the Regex for the given provider
 * @param cardCode - any cardcode string
 * @param giftCardProvider GiftCardProviders - import from utils
 * @returns
 */
export const giftCardCodeValidator = (cardCode: string, giftCardProvider: GiftCardProviders): boolean => {
  const giftCardRegex = getGiftCardRegex(giftCardProvider);
  return giftCardRegex.test(cardCode);
};

/**
 *
 * @param giftCardProvider
 * @returns the Regex used to validate a code from the given provider
 */
const getGiftCardRegex = (giftCardProvider: GiftCardProviders): RegExp => {
  switch (giftCardProvider) {
    case "DenBedsteGave":
      return /^(b|B)(g|G)(d|D)(k|K)(-|)\d{8}$/;
    case "GoDream":
      return /^\d{7} [A-Za-z0-9]{6}$|^\d{12} [0-9]{3}$|^\d{10} [0-9]{3}$/;
    case "GoGift":
      return /^(L|l)(G|g)(K|k)(-|)[A-Za-z0-9]{8}$|^[A-Za-z0-9]{16}(-|| )[0-9]{4,6}$/;
    case "MoreBox":
      return /^\d{13,16}$/;
    case "RaskRask":
      return /^(R|r)(A|a)(S|s)(K|k)\d{5,7}$|^(R|r)(R|r)\d{7}$/;
    case "SendEnTanke":
      return /^[A-Za-z0-9]{11}$/;
    case "SmartBox":
      return /^\d{9}$|^\d{12}$/;
  }
};
